const roles = {
    USER: "User",
}
export default roles;